import { IAppInfo } from "@electron-types/app-details";
import { createElectronPlugin } from "./electron-plugin.util";

export { IAppInfo };

interface AppDetailsPlugin {
    getAppInfo: () => Promise<IAppInfo>;
}

const AppDetailsElectron = createElectronPlugin<AppDetailsPlugin>('AppDetails');

export default AppDetailsElectron;
